import * as _ from 'lodash';

import { AppState } from "../classes/index";
import { defaultStepOneModel } from "../camp-sign-up/redux/reducers/step-one-reducer";
import { defaultStepTwoModel } from '../camp-sign-up/redux/reducers/step-two-reducer';
import { defaultStepThreeModel } from '../camp-sign-up/redux/reducers/step-three-reducer';
import { defaultStepFourModel } from '../camp-sign-up/redux/reducers/step-four-reducer';

export function extractCommonFields(): AppState {
    const rawData = localStorage.getItem("prev_camp_registration");

    if (rawData && rawData.length > 0) {
        let storedValue: AppState = JSON.parse(localStorage.getItem("prev_camp_registration"));

        let ret: AppState = {} as any;
        ret.stepOneModel = _.assign({}, defaultStepOneModel);
        // Copy over PARENT INFORMATION
        ret.stepOneModel.parentInformation = _.assign({}, storedValue.stepOneModel.parentInformation);

        ret.stepTwoModel = _.assign({}, storedValue.stepTwoModel, { transportationPermission: _.assign({}, storedValue.stepTwoModel.transportationPermission, { canTakePublicTransportation: null, canWalkHome: null }) });
        ret.stepThreeModel = _.assign({}, defaultStepThreeModel);
        ret.stepFourModel = _.assign({}, defaultStepFourModel);

        return ret;
    }

    return null;
}


// WEBPACK FOOTER //
// ./app/helpers/load-common-fields.ts